<template>
  <div id="wrap" v-loading="loading">
    <div class="flex flex-justify flex-wrap">
      <div>
        <el-form :inline="true">
          <el-form-item label="申报区间：">
            <el-date-picker
              v-model="value1"
              type="daterange"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['12:00:00']"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="primary" @click="generate"
          ><i class="el-icon-plus"></i> 生成</el-button
        >
      </div>
    </div>

    <div class="flex flex-justify title_box">
      <div>
        <i class="el-icon-warning" style="color: #4988df"> 生成记录 </i>
      </div>
      <div>
        <!--        <el-link type="primary" style="margin-left: 20px" :underline="false"
          >删除</el-link
        >-->
      </div>
    </div>

    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{ background: '#F5F7FA' }"
      stripe
      :row-class-name="tableRowClassName"
      row-key="fileId"
      :tree-props="{ children: 'boyList' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="辅助账名称" prop="fileName"></el-table-column>
      <el-table-column
        prop="name"
        :formatter="reFormat"
        label="申报区间"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="operator"
        label="操作员"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="generateTime"
        label="生成日期"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <!--          <el-button v-if="scope.row.type!=4" type="text" size="small" class="blue" @click="download(scope.row)">生成</el-button>-->
          <!--          <el-button type="text" size="small" class="blue">{{scope.row.type==4&&scope.row.}}</el-button>-->
          <el-button
            v-if="scope.row.type == 1"
            type="text"
            size="small"
            class="blue"
            @click="download(scope.row, 1)"
            >打包下载</el-button
          >
          <el-button
            v-if="scope.row.type == 1"
            type="text"
            size="small"
            class="green"
            @click="download(scope.row, 2)"
            >下载总账</el-button
          >
          <el-button
            v-if="scope.row.type == 4 && scope.row.isExist == 2"
            type="text"
            size="small"
            class="red"
            @click="download(scope.row, 3)"
            >去补充</el-button
          >
          <el-button
            v-if="
              scope.row.type != 1 &&
              (scope.row.type != 4 || scope.row.setIsExist == 1)
            "
            type="text"
            size="small"
            class="red"
            @click="download(scope.row, 2)"
            >下载</el-button
          >
          <!--          <el-button type="text" size="small" class="green" @click="download(scope.row)">下载</el-button>
          <el-button type="text" size="small" class="green" @click="download(scope.row)">下载</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <div class="flex flex-end">
      <el-pagination
        class="pagination"
        background
        layout="prev, pager, next,total"
        :total="total"
        :current-page.sync="queryParam.pageNum"
        :page-size.sync="queryParam.pageSize"
        @current-change="search"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  queryAuxiliaryAccounts,
  totalGenerate,
  downloadAccount,
  downloadAccounts,
} from "./index";
export default {
  data() {
    return {
      queryParam: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      loading: false,
      radio: "1",
      input1: "",
      value1: "",
      ruleForm: {
        name: "",
      },
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      tableData: [
        {
          date: "1",
          name: "技术部",
          address: "初始规则",
          year: "无",
          batch: "1",
          founder: "何永浩",
          creationtime: "2020-10-11",
          completeness: "25%",
          state: "申请中",
        },
      ],
      value: "",
      options: [
        {
          value: "1",
          label: "产品一部",
          children: [
            {
              value: "2",
              label: "研发部",
              children: [
                {
                  value: "3",
                  label: "软件",
                },
              ],
            },
          ],
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    download(row, type) {
      console.log(type);
      this.loading = true;
      if (type == 1) {
        //打包下载
        downloadAccounts({ id: row.id }).then((res) => {
          this.loading = false;
          if (res.code == "00000") {
            window.open(res.data);
          }
        });
      }
      if (type == 2) {
        //单个下载
        downloadAccount({ id: row.id, type: row.type }).then((res) => {
          this.loading = false;
          if (res.code == "00000") {
            window.open(res.data);
          }
        });
      }
      if (type == 3) {
        //去补充
        this.loading = false;
        this.$router.push("/centerform/expenditurePersonnel");
        sessionStorage.setItem("zt_jjkc_project_id", row.projectId);
        sessionStorage.setItem("zt_jjkc_jump", 1);
      }
    },
    generate() {
      if (this.value1.length != 2) {
        this.$message.error("申报区间格式不正确");
      } else {
        this.loading = true;
        totalGenerate({
          beginTime: this.value1[0],
          endTime: this.value1[1],
        }).then((res) => {
          this.loading = false;
          if (res.code == "00000") {
            this.msgSuccess("生成成功");
            this.search();
          }
        });
      }
    },
    init() {
      this.search();
    },
    reFormat(row, col) {
      if (row.type != 4) {
        return row.reportingIntervalBegin + "至" + row.reportingIntervalEnd;
      } else {
        return "";
      }
    },
    search() {
      this.loading = true;
      queryAuxiliaryAccounts(this.queryParam).then((res) => {
        this.loading = false;
        console.log(res);
        let id = 0;
        res.data.records.forEach((item) => {
          id++;
          item.fileId = id;
          item.boyList.forEach((boy) => {
            id++;
            boy.fileId = id;
          });
        });
        this.tableData = res.data.records;
        console.log(this.tableData);
        this.total = res.data.total;
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "background:#fff";
      } else {
        return "background:#F5F7FA";
      }
    },
  },
};
</script>
<style scoped>
.title_box {
  width: 100%;
  height: 40px;
  background-color: #e6f7ff;
  box-shadow: rgba(186, 231, 255, 1) solid 1px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 40px;
  padding: 0 20px;
  box-sizing: border-box;
  margin: 20px 0;
}
.form_box .el-form-item {
  width: 46%;
}
.text {
  font-size: 14px;
  padding: 10px 20px;
  position: relative;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 20px;
}
.text::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 18px;
  left: 10px;
  top: 10px;
  background: #7c99fd;
}
.gsadd {
  position: absolute;
  left: 17px;
  top: 20px;
  z-index: 9;
}
</style>
